
<template>
    <div class="relative">
        <Paragraph :title="$t('gpt.gptInnovation')" :noDataText="$t('noEfficacy')">

            <template #custom-icon>
                <div class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('gpt.gptInnovationTip')">
                    <IconGPT/>
                </div>
            </template>

            <!-- 免费版遮罩效果 -->
            <div v-if="isFreeUser" class="is-free-content h-[90px]"></div>

            <div v-else-if="loading" class="th-loading th-loading-spinner th-loading-md bg-grey-200"></div>

            <div v-else-if="gptSummary?.innovation_point?.length" class="flex flex-col gap-2" >
                <p class="text-sm leading-5 text-black" v-for="(item, index) in gptSummary?.innovation_point" :key="index">
                    {{ `${index+1}.${item}` }}
                </p>
            </div>

            <p v-else class="text-sm leading-5 text-black">
                {{ $t('gpt.noGPT')}}
            </p>
        </Paragraph>

        <Paragraph :title="$t('gpt.gptAvoidance')" :noDataText="$t('noEfficacy')">

            <template #custom-icon>
                <div class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('gpt.gptAvoidanceTip')">
                    <IconGPT/>
                </div>
            </template>

            <!-- 免费版遮罩效果 -->
            <div v-if="isFreeUser" class="is-free-content h-[90px]"></div>

            <div v-else-if="loading" class="th-loading th-loading-spinner th-loading-md bg-grey-200"></div>

            <div v-else-if="gptSummary?.improvement_direction?.length" class="flex flex-col gap-2" >
                <p class="text-sm leading-5 text-black" v-for="(item, index) in gptSummary?.improvement_direction" :key="index">
                    {{ `${index+1}.${item}` }}
                </p>
            </div>

            <p v-else class="text-sm leading-5 text-black">
                {{ $t('gpt.noGPT')}}
            </p>
        </Paragraph>

        <div v-if="isFreeUser" class="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center">
            <IconNoAuthGpt />
            <p class="mb-4 mt-2 text-center text-base text-black">
                {{ $t('gpt.freeUser') }}
            </p>
            <button class="th-btn" @click="upgradeNow">
                {{ $t('gpt.upgradeNow') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import IconGPT from '@/components/icons/IconGPT.vue'
import Paragraph from '@/components/detail/Paragraph.vue';
import { TRANSLATE_LANGUAGES } from '@/types';
import type { IPatentGPTSummary } from '@/types';
import IconNoAuthGpt from '@/components/icons/IconNoAuthGpt.vue'
import { getGPTSummary } from '@/infrastructure/api-functions';
import { hookErrorCode } from '@eureka/services/src/custom-error-handler';
import { EActivityTriggerType } from '@eureka/services/src/types/activity-type';
import { i18n } from '@/infrastructure/locales';

const props = defineProps<{
    gptSummary?: IPatentGPTSummary
    loading?: boolean
    isFreeUser?: boolean,
    patentId: string,
}>()

const LIMIT_CREATE = [90112043]

function upgradeNow() {
    const task = getGPTSummary({
        patent_id: props.patentId,
        lang: TRANSLATE_LANGUAGES.CHINESE,
        trans_lang: TRANSLATE_LANGUAGES.CHINESE,
    })

    hookErrorCode(task, LIMIT_CREATE, (error) => {
        import('@eureka/shared/upgrade-activity').then((mod) => {
            mod.openUpgradeActivity(i18n, { activityTriggerType: EActivityTriggerType.idea, error })
        })
    }).finally(() => {
        console.log('throw error');
    });
}

</script>

<style lang="scss">
.is-free-content {
    background-image: url('@/assets/images/free-user-gpt-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
